import { React, observer, classNames, useAsObservableSource, useEffect } from '@api'
import { Tooltip2 } from '@api'
import { Tooltip } from '@material-ui/core'
import { ErrorBoundary, ErrorBoundaryToast } from '@modules/common'
import {CatalogSeasonSelector, SeasonSelectorFilterDropdown} from '@modules/siteHeader'
import { icons } from '@stores/ui'
import { PrimaryIconButton } from 'centric-ui-components'
import * as css from './CatalogSeasonSelectors.css'
import { SeasonSelectorFieldConfig, StoresInstance, useCatalog } from '@stores'
import { HeaderSyncIndicator } from '@modules/syncIndicator'
import { useVipLocalStore, VipLocalStore } from '@modules'
import { computed } from 'mobx'
import {Md5} from 'ts-md5/dist/md5'

export interface ICatalogSeasonSelectors {
  align?: 'left' | 'right'
}

export class CatalogSeasonSelectorsStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: ICatalogSeasonSelectors) {
    super(stores)
  }
  @computed get selectedCollectionIds() {
    const { filter: { selectedCollectionIds } } = this
    return selectedCollectionIds
  }

  @computed get selectedHierarchyFilterUniqueId(){
    const {filter:{selectedHierarchyGroupFilters}} = this
    let hierarchyString = ''
    
    new Map([...selectedHierarchyGroupFilters].sort()).forEach((value, key)=>{hierarchyString += value.join('').trim()})
    const uniqueHash = Md5.hashStr(hierarchyString)
    // console.log('Hierarchy String ', hierarchyString)
    // console.log('Unique hash ', uniqueHash)
    return uniqueHash
  }
  @computed get filteredArr() {
    const { props: { align }, catalog: { seasonSelectorFields } } = this
    return seasonSelectorFields.filter(s => !align || s.align == align || (!s.align && align == 'right'))
  }
}

export const CatalogSeasonSelectorsStoreContext = React.createContext<CatalogSeasonSelectorsStore>(null)
export const useC8FlexLayoutTabStore = () => React.useContext(CatalogSeasonSelectorsStoreContext)

export const CatalogSeasonSelectors = observer<ICatalogSeasonSelectors>(function CatalogSeasonSelectors({ align }) {
  const { strings, seasonSelectorFields, clearSeasonSelection, filter, vlp } = useCatalog(),
    obsProps = useAsObservableSource({ align }),
    store = useVipLocalStore((stores) => new CatalogSeasonSelectorsStore(stores, obsProps))
  const { selectedCollectionIds, filteredArr, selectedHierarchyFilterUniqueId } = store
  
  // useEffect(() => {
  //   vlp?.hierarchy?.fetchLastSyncTime('filter', selectedHierarchyFilterUniqueId)
  // }, [selectedHierarchyFilterUniqueId])

  return <CatalogSeasonSelectorsStoreContext.Provider value={store}>
    {seasonSelectorFields?.length ?
      <div className={css.root} data-type='CatalogSeasonSelectors'>
        {filteredArr.map((field, i) =>
          <ErrorBoundaryToast key={field.field}>
            <CatalogSeasonSelector key={field.field} className={css.seasonSelector} field={field} />
          </ErrorBoundaryToast>)}
        {vlp && !_.isEmpty(filteredArr) && !_.isEmpty(selectedCollectionIds) && <HeaderSyncIndicator lastSyncTimeMap={vlp?.hierarchy?.lastSyncTimeMap} itemId={selectedHierarchyFilterUniqueId} trigger='filter' />}
        {align === 'left' && seasonSelectorFields.some(f => filter.hasSelections(f.field)) && <Tooltip2 content={`${strings.clear} Seasons`}>
          <PrimaryIconButton showOnHover icon={icons.clear} onClick={clearSeasonSelection} />
        </Tooltip2>}
      </div> : null}
  </CatalogSeasonSelectorsStoreContext.Provider>
})



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/CatalogSeasonSelectors.tsx